export default __webpack_public_path__ + "static/media/connections_lg_icon.8e871c85.svg";